import React, {useCallback, useContext} from "react";
import TriggerRC from '@rc-component/trigger';
import cn from "classnames";
import '@rc-component/trigger/assets/index.css';
import './style.css'

const builtinPlacements = {
  left: {
    points: ['cr', 'cl'],
  }, right: {
    points: ['cl', 'cr'],
  }, top: {
    points: ['bc', 'tc'],
  }, bottom: {
    points: ['tc', 'bc'],
  }, topLeft: {
    points: ['bl', 'tl'],
  }, topRight: {
    points: ['br', 'tr'],
  }, bottomRight: {
    points: ['tr', 'br'],
  }, bottomLeft: {
    points: ['tl', 'bl'],
  },
};

const DropdownTrigger = React.forwardRef((props, ref) => {
  return (
    <span ref={ref} {...props} className={cn('dropdown-trigger', props.className)}
    />
  )
});

const DropdownPopup = function (props) {
  return (
    <div {...props} className={cn('dropdown-popup', props.className)}/>
  )
}

const DropdownOption = function ({children, icon, className, onClick, disabled, ...other}) {
  const Tag = other.href ? 'a' : 'div'
  const context = useContext(DropdownContext)
  const onClickHandler = useCallback((e) => {
    if (onClick) onClick(e)
    context.close()
  }, [onClick])
  return (
    <Tag onClick={onClickHandler} className={cn('dropdown-option', {
      '-disabled': disabled,
    }, className)} {...other}>
      {children}
      {icon && <span className="dropdown-option-icon">{icon}</span>}
    </Tag>
  )
}

const DropdownContext = React.createContext()

class Dropdown extends React.Component {

  static Option = DropdownOption

  state = {
    visible: false
  }

  handlerVisible = (visible) => {
    this.setState({visible})
  }

  getContext() {
    return {
      close: () => {
        this.setState({visible: false})
      }
    }
  }

  render() {
    const {
      trigger, triggerProps = {},
      offset = 0,
      children
    } = this.props
    const {visible} = this.state

    return (
      <DropdownContext.Provider value={this.getContext()}>
        <TriggerRC
          popupVisible={visible}
          onOpenChange={this.handlerVisible}
          action={['click']}
          popup={<DropdownPopup children={children}/>}
          popupAlign={{
            points: ['tr', 'br'],
            offset: [offset, offset],
          }}
        >
          <DropdownTrigger {...triggerProps}>
            {typeof trigger === 'function' ? trigger() : trigger}
          </DropdownTrigger>
        </TriggerRC>
      </DropdownContext.Provider>
    )
  }
}

export default Dropdown